<template>
    <div class="frmlogin_cont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>

        <GrcNum ref="txtTagkod" v-model="txtTagkod" 
        grc_labeltext="Tagkód:"
        grc_placeholder="..."
        grc_currency="" grc_decimalplaces="0" grc_readonly="false"
        grc_textalign="left"
        grc_labelmode="" grc_labelwidth="200px" 
        v-on:grc-keydown-enter="SetControlToFocus('txtJelszo');"
        style="margin-bottom:20px;"
        />

        <GrcText ref="txtJelszo" v-model="txtJelszo" 
        grc_ispassword="true"
        grc_labeltext="Jelszó:"
        grc_placeholder="..."
        grc_labelmode="" grc_labelwidth="100px" 
        v-on:grc-keydown-enter="SetControlToFocus('');"
        style="margin-bottom:20px;"
        grc_canshowpassword="mobilapp"
        />

        <table style="width:100%; margin-bottom:30px; display:none;" cellspacing="0" cellpadding="0">
        <tr>
            <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkStoreEmail" /></td>
            <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:14px; line-height:18px; color:#222;" v-html="txtStoreEmail">
            </td>
        </tr>
        </table>

        <div class="frmlogin_btncont">
          <span class="cms_linkbutton cms_linkbutton_2" @click="btnLogin_click"><span><i class="fal fa-check" style="margin-right:10px;"></i>Bejelentkezés</span></span>
        </div>


    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'


export default {
  name: 'frmlogin',
  components: {
      GrcText,
      GrcNum,
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmlogin_",

          txtTagkod: 0,
          txtJelszo: "",

          txtStoreEmail: "",

      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmlogin", pCompName);
    },

    SetLang()
    {
      /*
        this.$refs.txtEmailCim.SetLabel(this.GetTextBookItem("txtEmailCim"));
        this.$refs.txtJelszo.SetLabel(this.GetTextBookItem("txtJelszo"));
        this.$refs.btnLogin.SetLabel(this.GetTextBookItem("btnLogin"));
      */
        this.txtStoreEmail = this.GetTextBookItem("txtStoreEmail");


        this.$refs.txtTagkod.HideError();
        this.$refs.txtJelszo.HideError();

        if (GRCAPP_MAILREM == "")
        {
          //this.SetControlToFocus("txtEmailCim");
        }
        else
        {
          //this.SetControlToFocus("txtJelszo");
        }

    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },

      btnLogin_click()
      {
          this.Login();
      },

      async Login()
      {
        gXLMS = "";
        
        var ErrorCompName = "";

        if (this.$refs.txtTagkod.GetValue() < 1)
        {
          this.$refs.txtTagkod.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtJelszo.GetText() == "")
        {
          if (ErrorCompName == "") { ErrorCompName = "txtJelszo"; }
          this.$refs.txtJelszo.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }

        let pCurrentAlias = "";
        if (GRCAPP_GetParameters.hasOwnProperty("ALIAS"))
        {
          pCurrentAlias = GRCAPP_GetParameters.ALIAS;
        }



        this.$refs.GRCDB.ShowLoading(false);

        // szerver oldali CSS beállítások böngészőhöz optimalizálása érdekében
        var pAgent = grcmain_GetAgent()+": "+navigator.userAgent;
        if (typeof pAgent == "undefined") { pAgent = "unknown"; }


        var QP = { 
            iTagkod: this.$refs.txtTagkod.GetValue(),
            sJelszo: this.$refs.txtJelszo.GetText(),
            sCurrentAlias: pCurrentAlias,
            sIPAddress: "[IPADDRESS]",
            sBrowserAgent: pAgent,
            iRememberMail: this.$refs.chkStoreEmail.GetValue()

        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "login", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        document.cookie = "XLMS=; Secure";
        
        if (Q.LOGINRESULT[0].intResult != 1)
        {
            this.$refs.txtTagkod.ShowError(Q.LOGINRESULT[0].strResult);
            this.SetControlToFocus("txtTagkod");

            return;
        }

        /*
        GRCAPP_MAILREM = "";
        var emailrem = "";
        emailrem = ""+this.$refs.chkStoreEmail.GetValue()+";";
        if (this.$refs.chkStoreEmail.GetValue() == 1)
        {
          emailrem = emailrem + this.$refs.txtTagkod.GetValue();
          GRCAPP_MAILREM = this.$refs.txtTagkod.GetValue();
        }
        else { emailrem = emailrem + "no"; }

        this.$emit("emailremember", emailrem);
        */
        
        document.location = Q.LOGINRESULT[0].RedirUrl;

      },

    async ShowLoginError(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
        
        this.SetControlToFocus("txtTagkod");
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();

    if (gAppInitDone)
    {
      if (grcmain_GetAppTypeID() != 0)
      {
        gRouteMode = "replace";
        this.$emit("navigate", "default");
      }
    }

    this.$refs.txtTagkod.SetValue(parseInt("0"+GRCAPP_MAILREM));

    if (GRCAPP_MAILREM != "")
    {
      this.$refs.chkStoreEmail.SetValue(1);
    }
    
  }

}


</script>


